import { render } from "./InstallerSteps.vue?vue&type=template&id=496c1308&scoped=true"
import script from "./InstallerSteps.vue?vue&type=script&lang=js"
export * from "./InstallerSteps.vue?vue&type=script&lang=js"

import "./installer-steps.scss?vue&type=style&index=0&id=496c1308&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/installer/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-496c1308"]])

export default __exports__